module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "primary": ""
    }
  }, [(_vm.user.authenticated && (_vm.hasRole('evaluator') || _vm.hasRole('proeng'))) ? _c('v-navigation-drawer', {
    attrs: {
      "clipped": "",
      "app": "",
      "light": "",
      "fixed": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Menu")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.enabledItems), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "value": "true",
        "to": item.to
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [(item.title === 'Avaliar trabalho' && _vm.user.type === '4') ? _c('v-list-tile-title', {
      attrs: {
        "color": "warning"
      }
    }, [_c('b', [_vm._v(_vm._s(item.title))])]) : (item.title === 'Reservar materiais de informática') ? _c('v-list-tile-title', {
      attrs: {
        "color": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.goToCAPI(_vm.user.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  }), _vm._v(" "), (_vm.user.authenticated) ? _c('v-list-tile', {
    attrs: {
      "value": "true"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary elevation-1",
    attrs: {
      "fixed": "",
      "clipped-left": "",
      "app": "",
      "dark": "",
      "dense": _vm.$vuetify.breakpoint.xsOnly
    }
  }, [(_vm.user.authenticated && (_vm.hasRole('evaluator') || _vm.hasRole('proeng'))) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": "https://minha.unifebe.edu.br/sisbanca/imgs/logo-branca-bancas.png"
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/cronograma",
      "exact": "",
      "title": "Cronograma"
    }
  }, [_c('v-icon', {
    class: !_vm.mobile ? 'mr-2' : '',
    attrs: {
      "left": !_vm.mobile,
      "dark": ""
    }
  }, [_vm._v("today")]), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v(" Cronograma")])], 1), _vm._v(" "), (!_vm.user.authenticated) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/entrar"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("power_settings_new")]), _vm._v(" Entrar\n      ")], 1) : _vm._e(), _vm._v(" "), (_vm.user.authenticated) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "title": 'Logado como ' + _vm.user.name + ' (' + _vm.user.id + ')'
    }
  }, [_c('v-icon', {
    class: !_vm.mobile ? 'mr-2' : '',
    attrs: {
      "left": !_vm.mobile,
      "dark": ""
    }
  }, [_vm._v("person")]), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " (" + _vm._s(_vm.user.id) + ")")])], 1) : _vm._e(), _vm._v(" "), (_vm.mobile && _vm.screenfull.enabled) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [(!_vm.isFullscreen) ? _c('v-icon', [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.isFullscreen) ? _c('v-icon', [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.authenticated || _vm.mobile) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "origin": "bottom right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(_vm.mobile) ? _c('v-list-tile', {
    attrs: {
      "value": "true",
      "href": "https://docs.google.com/document/u/2/d/e/2PACX-1vRrFT6DklCW-ifgP9Fz3EmAGT2pJeppMqzjmsJNgV8jpEV5d0L9zWWWH7wQu4Rde1PihFPzFtBU8rRN/pub",
      "target": "_blank"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Ajuda")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.authenticated) ? _c('v-list-tile', {
    attrs: {
      "value": "true"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sair")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.mobile) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "title": "Ajuda",
      "href": "https://docs.google.com/document/u/2/d/e/2PACX-1vRrFT6DklCW-ifgP9Fz3EmAGT2pJeppMqzjmsJNgV8jpEV5d0L9zWWWH7wQu4Rde1PihFPzFtBU8rRN/pub",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    class: !_vm.mobile ? 'mr-2' : '',
    attrs: {
      "left": !_vm.mobile,
      "dark": ""
    }
  }, [_vm._v("help")]), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v(" Ajuda")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "primary hidden-sm-and-down",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": ""
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.footerText))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187bd929"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 240
// module chunks = 0